module.exports = __webpack_public_path__ + "static/media/workload-arrow-left.7d079d18.svg";